
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.p2c-about-craft-luxe').forEach((section) => {
    const track = section.querySelector('[data-p2c-craft-track]');
    const cards = [...section.querySelectorAll('[data-p2c-craft-card]')];
    const dots = [...section.querySelectorAll('[data-dot-index]')];

    if (!track || cards.length === 0 || dots.length === 0) return;

    const updateDots = () => {
      const trackLeft = track.getBoundingClientRect().left;
      let activeIndex = 0;
      let smallestDistance = Infinity;

      cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    };

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateDots();
        ticking = false;
      });
    }, { passive: true });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        cards[index]?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      });
    });

    updateDots();
  });
});
